import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
import { WorkflowService } from 'tnx-admin-service/workflowcore/workflow/services';
@Component({
    selector: 'workflow',
    templateUrl: './workflow.component.html',
    styleUrls: ['./workflow.component.scss'],
    providers: [ComponentContextService],
})
export class WorkflowComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _workflowService: WorkflowService,
    ) {
        super(_injector);

    }

    ngOnInit() {
        this.setting.baseService = this._workflowService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'persistenceId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'completeTime', dataType: 'date', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'createTime', dataType: 'date', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'data', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'description', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'nextExecution', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'status', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'workflowDefinitionId', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'reference', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'stepMetadata', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'persistenceId' }),
            new ColumnSchemaBase({ field: 'completeTime' }),
            new ColumnSchemaBase({ field: 'createTime' }),
            new ColumnSchemaBase({ field: 'data' }),
            new ColumnSchemaBase({ field: 'description' }),
            new ColumnSchemaBase({ field: 'nextExecution' }),
            new ColumnSchemaBase({ field: 'status' }),
            new ColumnSchemaBase({ field: 'workflowDefinitionId' }),
            new ColumnSchemaBase({ field: 'reference' }),
            new ColumnSchemaBase({ field: 'stepMetadata' }),
            new ColumnSchemaBase({ field: 'code' }),
            new ColumnSchemaBase({ field: 'currentStateCode' })
        ];

        super.ngOnInit();
    }
}

